<template>
  <size-table :row-header-fallback="bp('size')" />
</template>

<script>
import SizeTable from '@/components/SizeTable.vue';
export default {
  components: {SizeTable},
};
</script>

<style></style>
